import { setDate } from "./setDate";
import { Modal as customModal } from 'antd';
import { stripHtmlAndExtractColor } from "./stripHtmlAndExtractColor";


export const printpdfFun = (drillPathDataMap, filename,levelwisehead) => {

const getOriginalHeaderKey = (key, level, index) => {
  const headers = levelwisehead[`level${level}`] || [];
  return headers[index] || headers.find(h => h.toLowerCase() === key.toLowerCase()) || key;
};

  if (!drillPathDataMap || Object.keys(drillPathDataMap).length === 0) {
    customModal.warning({
      title: 'Oops',
      content: 'No data available to print.',
      centered: true,
      cancelButtonProps: { style: { display: 'none' } },
      maskClosable: false,
    });
    return;
  }

  let html = "";

Object.entries(drillPathDataMap).forEach(([levelKey, data]) => {
  if (!data || data.length === 0) return;

  const headers = Object.keys(data[0]).filter(key => key.toLowerCase() !== "drilldownquery");

  html += '<table><thead><tr>';
  headers.forEach((header, index) => {
    const originalHeader = getOriginalHeaderKey(header, levelKey.replace('level', ''), index);
    html += `<th>${originalHeader}</th>`;
  });
  html += '</tr></thead><tbody>';


    data.forEach((row) => {
      html += "<tr>";
      headers.forEach((key) => {
        let cellValue = row[key];

        if (typeof cellValue === "object" && cellValue !== null) {
          cellValue = 'value' in cellValue ? cellValue.value : setDate(cellValue.date);
        }

        if (typeof cellValue === "string" && cellValue.includes("<img")) {
          const imgMatch = cellValue.match(/<img[^>]*src=["']?([^"'>]+)["']?[^>]*>/i);
          const imgSrc = imgMatch?.[1] ?? "";
          html += `<td><img src="${imgSrc}" alt="Image" style="max-width: 80px; max-height: 80px;" onerror="this.onerror=null; this.src='fallback.png';" /></td>`;
        } else {
          let textcontent = "";
          let style = '';
          if (typeof cellValue === "string") {
            const { text, color, bold, backgroundColor, margin, padding, textAlign ,fontSize} = stripHtmlAndExtractColor(cellValue);
              textcontent = text ? bold ? `<b>${text}</b>` : text :  ""

if (color) style += `color: ${color};`;
if (backgroundColor) style += `background-color: ${backgroundColor};`;
if (margin) style += `margin: ${margin};`;
if (padding) style += `padding: ${padding};`;
if (textAlign) style += `text-align: ${textAlign};`;
if (fontSize) style += `font-size: ${fontSize};`;

          } else if (cellValue !== null && cellValue !== undefined) {
            textcontent = String(cellValue);
          }
        
          html += `<td style="${style}">${textcontent}</td>`;
        }
      });
      html += "</tr>";
    });

    html += "</tbody></table><br/><br/>";
  });

  const frame = document.createElement('iframe');
  frame.style.position = 'fixed';
  frame.style.right = '0';
  frame.style.bottom = '0';
  frame.style.width = '0';
  frame.style.height = '0';
  frame.style.border = '0';
  document.body.appendChild(frame);

  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(`
    <html>
      <head>
        <title>${filename}</title>
        <style>
  @media print {
    @page {
      size: landscape;
      margin: 10mm;
    }
      body {
      counter-reset: page;
 -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
  }
    table td, table th {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    .footer::after {
      content: counter(page);
    }

    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      font-size: 10px;
      display: flex;
      justify-content: space-between;
      padding: 4px 20px;
    }

    thead { display: table-header-group; }
  }

  body {
    font-family: Arial, sans-serif;
    padding: 10px;
    text-align: center;
  }

  .report-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .printed-time {
    font-size: 10px;
    margin-bottom: 12px;
  }

  table {
    width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  }

  th, td {
   border: 1px solid #000;
  padding: 4px;
  text-align: center;
  font-size: 9px;
  overflow: hidden;
  white-space: pre-line;
  word-break: normal;
  overflow-wrap: break-word;
  }

  th {
    background-color: #f2f2f2;
  }

  img {
    display: block;
    margin: 0 auto;
  }
  img {
    display: block;
    margin: 0 auto;
  }
</style>

      </head>
      <body>
      
      
        ${html}
       
      </body>
    </html>
  `);
  doc.close();
  frame.contentWindow.focus();

  setTimeout(() => {
    frame.contentWindow.print();
  }, 500);

  setTimeout(() => {
    document.body.removeChild(frame);
  }, 1000);
};